export const useRequireCompat = ({ path, glob }) => {
  // dynamically load assets on vite via glob extraction
  const file = Object.entries(glob())
    .filter(([fileName]) => {
      return fileName.replace(/^\/src/, '@').includes(path)
    })
  if (file.length) {
    const [, fileLoader] = file[0]
    return typeof fileLoader === 'function' ? fileLoader() : fileLoader
  }
}
